if (!customElements.get("product-modal")) {
  customElements.define(
    "product-modal",
    class ProductModal extends HTMLElement {
      constructor() {
        super();
        const buttons = document.querySelectorAll('.product-media-gallery .product-media-gallery__item-zoom');
        this.closeButton = this.querySelector('.product-media-modal__close');
        buttons.forEach(button => {
          button.addEventListener('click', this.showActiveMedia.bind(this));
        });

        this.closeButton.addEventListener('click', this.hideModal.bind(this));
      }

      hideModal() {
        this.removeAttribute('open');
      }

      showActiveMedia(event) {
        this.setAttribute('open', true);
        this.querySelectorAll('[data-media-id]').forEach(element => {
          element.classList.remove('active');
        });

        const id = event.currentTarget.getAttribute('data-button-media-id');
        const activeMedia = this.querySelector(`[data-media-id="${id}"]`);
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();
      }
    },
  );
}